// Business hours for a location. Each day is one of three states:
//   closed              → closed: true
//   open 24 hours       → closed: false, open24: true
//   bounded open/close  → closed: false, open24: false, openTime/closeTime set
// A day whose closeTime is earlier than its openTime runs overnight and closes
// on the following calendar day (e.g. 20:00 – 02:00).

export const DAYS_OF_WEEK = [
	'MONDAY',
	'TUESDAY',
	'WEDNESDAY',
	'THURSDAY',
	'FRIDAY',
	'SATURDAY',
	'SUNDAY',
] as const;

export type DayOfWeek = (typeof DAYS_OF_WEEK)[number];

export interface BusinessHoursDay {
	dayOfWeek: DayOfWeek;
	closed: boolean;
	open24: boolean;
	openTime: string;
	closeTime: string;
}

export interface UpdateBusinessHoursRequest {
	days: BusinessHoursDay[];
}
